import {ItemType} from '../../base-components/StudioDataset/FileViewer';
import {CategoryType, DataPrepareType} from '../dataset/DatasetGetAnnotationsResponse';

export const METADATA_INFO = 'annotation/common_info';
export const METADATA_LABEL = 'annotation/label';
export const METADATA_BBOX = 'annotation/bounding_box';
export const METADATA_IMAGE = 'binary/image';
export const METADATA_VIDEO = 'binary/video';
export const METADATA_CATEGORY = 'annotation/categories_list';

export type BINARY_TYPES = 'binary/image' | 'binary/video';

export type CategoryList = {[key: number]: string};
export type DistributionCount = {name: string; count: number};
export type SplitDistributionCount = {[key: number]: number};
export type SplitDistributionTotal = {[key: string]: number};
export type SplitDistributionList = {[key: string]: SplitDistributionCount};
export type DatasetMetadataBinaryItem = {
  author: string;
  created: string;
  group: string;
  height: number;
  id: string;
  mediaSubType: string;
  mediaType: string;
  originalPath: string;
  size: number;
  type: BINARY_TYPES;
  updated: string;
  width: number;
};

export type DatasetMetadataLabelItem = {
  id: string;
  binaryId: string;
  category: number;
  // Fields below are used for detection only
  topLeftX?: number;
  topLeftY?: number;
  width?: number;
  height?: number;
};

export type DatasetMetadataMethodItem = {
  id: string;
  name?: string;
  description?: string;
  custom?: {
    method: DataPrepareType;
  };
};

export type DatasetMetadataCategories = {
  id: string;
  categories: CategoryList;
  //formated categories
  formattedCategories: CategoryType[];
};

export type DatasetMetadataLabels = {
  list: DatasetMetadataLabelItem[];
  totalElements: number;
  totalPages: number;
};

export type DatasetMetadataSplit = {
  author: string;
  batchId: string;
  created: string;
  height: number;
  id: string;
  metadataSource: string;
  type: string;
  updated: string;
  distribution: SplitDistributionList;
  distributionTotals?: SplitDistributionTotal;
  labelTotals?: SplitDistributionCount;
};

// TODO: might need to remove this
export type DatasetMetadata = {
  list:
    | DatasetMetadataBinaryItem[]
    | DatasetMetadataMethodItem[]
    | DatasetMetadataCategories[]
    | DatasetMetadataLabels[]
    | DatasetMetadataSplit[];
  totalElements: number;
  totalPages: number;
};

export type DatasetMetadataBinaries = {
  list: DatasetMetadataBinaryItem[];
  formattedBinaries: ItemType[];
  totalElements: number;
  totalPages: number;
};

export type DatasetMetadataSplits = {
  list: DatasetMetadataBinaryItem[];
  totalElements: number;
  totalPages: number;
};

export type DatasetMetadataMethod = {
  list: DatasetMetadataMethodItem[];
  totalElements: number;
  totalPages: number;
};

export type DatasetMetadataResponse = {
  body: DatasetMetadata;
};

export type DatasetMetadataDeleteRequest = {
  type: 'deletion_marker';
  id: string; //UI generated temp ID
  originalIds: string[];
};

export type DatasetMetadataDeleteResponse = any;

export type DatasetMetadataUpdateRequest = {
  list: DatasetMetadataBinaryItem[];
  totalElements: number;
  totalPages: number;
};

export type DatasetMetadataLabelUpdateRequest = {
  id: string; // temp Id
  type: 'annotation/bounding_box';
  binaryId: string;
  topLeftX: number;
  topLeftY: number;
  width: number;
  height: number;
  category?: number;
};
